import { useEffect, useRef } from 'react';

// A single, tasteful tab-title nudge when the visitor switches away — no rapid
// emoji cycling, no audio, no notification-permission prompts.
const TITLE_AWAY = '\u{1F44B} Come back to Account Editor';

export default function useTabAttention() {
  const titleBeforeAway = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    // Only ever restore a title this hook itself replaced. A tab can load or
    // navigate while hidden (middle-click, session restore, prerender), and
    // useDocumentMeta sets the real per-route title independently — blindly
    // restoring a title captured at mount would clobber it with a stale one.
    const restore = () => {
      if (titleBeforeAway.current !== null && document.title === TITLE_AWAY) {
        document.title = titleBeforeAway.current;
      }
      titleBeforeAway.current = null;
    };

    const onVisibility = () => {
      if (document.hidden) {
        titleBeforeAway.current = document.title;
        document.title = TITLE_AWAY;
      } else {
        restore();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      restore();
    };
  }, []);
}
